(function (module) {
    "use strict";

    module.component('marketNameEdit', {
        template: require('./marketNameEditComponent.html'),
        bindings: {
            resolve: '<',
            dismiss: '&',
            close: '&'
        },
        controller: ['$scope', function(this: $TSFixMe, $scope: $TSFixMe) {
            var $ctrl = this;

            $ctrl.$onInit = function () {
                $scope.model = $ctrl.resolve.model;
                $ctrl.options = $ctrl.resolve.options;
                if (!$ctrl.options.modalHeader) {
                    if ($ctrl.options == 'add') {
                        $ctrl.options.modalHeader = 'CONFIGURATION.MARKET_NAME.TITLE_ADD';
                    } else if ($ctrl.options == 'edit') {
                        $ctrl.options.modalHeader = 'CONFIGURATION.MARKET_NAME.TITLE_EDIT';
                    }
                }
                if (!$ctrl.options.nameHeader) {
                    $ctrl.options.nameHeader = 'CONFIGURATION.MARKET_NAME.NAME';
                }

            };
            $ctrl.ok = function () {
                $ctrl.close({
                    $value: {
                        id: $scope.model.id,
                        name: $scope.model.name
                    }
                });
            };

            $ctrl.cancel = function () {
                $ctrl.dismiss({
                    $value: 'cancel'
                });
            };
        }]
    })

})(angular.module('topline.modules'));